import { render, staticRenderFns } from "./single-ebook-card-content.vue?vue&type=template&id=ea67e9d4&"
import script from "./single-ebook-card-content.vue?vue&type=script&lang=js&"
export * from "./single-ebook-card-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports